export default __webpack_public_path__ + "static/media/Vidyashankar.a3db4a31.JPEG";